import MicrosoftSvg from '../../../../assets/icons/Microsoft.svg';
import type { ProviderIconComponent } from '../../types';

const MicrosoftIcon: ProviderIconComponent = ({ size = 24 }) => (
  <span
    style={{
      width: size,
      height: size,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <MicrosoftSvg style={{ width: '100%', height: '100%' }} />
  </span>
);

export default MicrosoftIcon;
